var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlandsbanken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1091.9 82.1",
    style: {
      enableBackground: "new 0 0 1091.9 82.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006940"
    },
    d: "M108.9,82c-0.1-27.7,0-32.1,0-48.5c-7.8-13.5-0.4-0.7-8.2-14c11.4,0,22.7,0,34.1,0c0,15.7,0,31,0,46.6 c11.2,0.1,22.2,0,33.4,0.1c-8.4,15.3-0.1,0.4-8.7,15.8C148.2,82,127,82,108.9,82"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006940"
    },
    d: "M277.7,82c0-16.2,0-31.9,0-48.1c-8.2-14-0.3-0.4-8.5-14.5c27.4,0,35.5,0,48.4,0c17.9,28.8,0.5,0.9,18.1,29.1 c0-9.7,0-19.4,0-29.1c7.1,0,14.2,0,21.2,0c0,21.2,0,38.2,0,62.6c-11.1,0-22.6,0-33.6,0c-23.9-37.6-0.4-0.9-24.2-38.1 c-0.1,12.8,0,18.5,0,38.1C289.9,82.1,285.8,82.1,277.7,82"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006940"
    },
    d: "M883,82c-15.5-25.2-0.3-0.6-15.9-25.7c-0.1,8.9,0.1,16,0,25.6c-8.9,0.1-16.9,0.1-25.5,0.1c0-12.4,0-32,0.1-48.7 c-7.9-13.3-0.3-0.6-8.3-13.9c11.4,0,22.3,0,33.7,0c0,11.2,0,22.3,0,34c10.2-11.1,20.8-22.8,30.9-34c6.2,0,9.4,0,18,0 c-23.1,25.7-1.3,1.3-24.1,26.8c20.7,34.7,0.7,1.3,21.4,35.8C901.1,82,891.8,82,883,82"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006940"
    },
    d: "M929,33c-6.7-11.2-0.4-0.8-8.2-13.5c23.9-0.1,47.8-0.1,71.8-0.1c8.2,13.3,0.3,0.7,8.5,13.9 c-15.4,0-30.4,0-45.8,0c0,2.9,0,6.9,0,10.2c6.5,0,12.8,0,19.2,0c0,4.7,0,8.9,0,13.5c-6.4,0-12.9-0.1-19.2,0c0,3.9,0,7.5,0,11.6 c15.5,0,30.7,0,46.2,0c-6.7,12.8-0.5,0.8-7,13.5c-31.7,0-43.7,0-65.5,0C929,65.5,929,49.5,929,33"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006940"
    },
    d: "M462.3,66.1c27.2,0,29,0,50.3,0.1c3.6-1,3.5-6.5,0.1-7.2c-40.1,0.4-49.8,0-50.4-19 c-0.2-11.8,9.1-19.9,16.3-20.6c16.2,0,32.3-0.1,48.7,0c1.7,2.8,7.8,12.8,8.4,13.8c-13.8,0-25.1,0-41,0c-2.7,1-3.5,5.4-0.1,6.6 c17.1-0.1,23.6,0,34.2,0c19.6,3.2,19.7,39.5-0.7,42.1c-18.4,0-26.9,0-56,0C463,67.1,471.7,81.3,462.3,66.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006940"
    },
    d: "M425.5,19.9c-9.4-0.6-15.7-0.4-57.5-0.4c8.2,13.5,0.4,0.7,8.4,13.9c-0.1,16.5-0.1,32.1-0.1,48.7 c29.8,0,39.6,0.2,49-0.6c16.7-1.2,28.1-15.2,28.1-28C453.5,37.1,445.5,23.1,425.5,19.9z M402.6,68.5c0-14-0.1-24.5,0-35.1 c15.5-1,23,2.9,22.8,19.5C424.8,65.6,419,69.7,402.6,68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006940"
    },
    d: "M737.1,82c-36.5-59.3-1-1.7-38.6-62.6c-15.2,0-30.4,0-45.7,0c8.7,13.4,0.6,0.8,8.9,13.8 C653,49.4,644.3,65.8,635.7,82c8.4,0,12.3,0,20.1,0c5.8-11.6,1.4-2.7,6.8-13.5c12.3,0,24.8,0,37.2,0c-6.6,12.1-0.8,1.3-7.4,13.5 C707.4,82,721.9,82,737.1,82z M671.2,53.4c7.5-14.6,0.5-1,7.8-15.2c8.7,13.1,0.6,0.6,10.1,15.2C682.3,53.4,678.5,53.4,671.2,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006940"
    },
    d: "M102.3,82.1c-13-20.9-25.9-41.8-38.7-62.6c-15.3,0-30.5-0.1-45.8,0c8.6,13.7,0,0.1,8.5,13.7 C0,81.8,26.2,33.2,0,82V82c20,0.1,0-0.1,20.1,0c6.5-12.2,0.9-1.5,7.2-13.5c16.5,0,16.9,0,37.2,0c-6.6,12.4-0.4,0.6-7.3,13.5 C72.3,82.1,87.2,82.1,102.3,82.1z M53.8,53.4c-16.7,0.1-1.5,0.1-18,0h-0.1c7.9-14.5,0.5-1.1,8.7-15.6C53.4,52.3,54,53.1,53.8,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006940"
    },
    d: "M269.6,82.1c-37.5-60.7-0.8-1.3-38.7-62.6c-17.6-0.1-22.1-0.1-45.8-0.1c7.9,12.6,0.5,0.8,8.5,13.8 C169,79.4,167.7,82,167.6,82c6.7,0,13.5,0,20.2,0c6.5-13,0.4-0.7,6.9-13.5c12.6,0,24.8,0,37.3-0.1c-6.4,12.1-0.9,1.6-7.2,13.6 C241.3,82.1,254.7,82.1,269.6,82.1z M203.2,53.4c8.2-15.2,0.1-0.4,8.4-15.5c9.2,14.7,0.5,0.8,9.7,15.4 C212.9,53.4,209.7,53.4,203.2,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006940"
    },
    d: "M619.9,49.6c0-0.2,0-0.4,0-0.5c6.7-3.2,9.5-9.6,9.2-15.7c-0.5-8.9-6.2-13-14.5-13.9 c-22.3,0.1-29.2-0.1-66.9-0.1c7.9,13.1,0.4,0.6,8.4,13.9c0,16.7,0,30.2-0.1,48.7c22.8,0,35.8,0.1,62.1,0 C637.8,79.8,635.4,51.8,619.9,49.6z M582.2,33.3c13.8,0.3,19.8-1.3,20.1,4.5c-0.3,6.8-7.9,5-20.1,5.3 C582.2,39.9,582.3,36.4,582.2,33.3z M582.1,68.6c0-5.2,0-5.9,0-12.1c16.3,0.1,22.4-0.9,22.9,6.3C604.6,69.9,598.2,68.2,582.1,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006940"
    },
    d: "M29.5,14.1c-8.2-13.5-0.1,0-8.6-14C38.2,0,41.5,0,51.3,0c8.8,13.8,0.4,0.6,8.9,14 C49.9,14.1,39.7,14.1,29.5,14.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006940"
    },
    d: "M745.9,82c0-16.2,0-31.9,0-48.1c-8.1-14-0.3-0.4-8.4-14.5c27.5,0,35.5,0,48.3,0c17.9,28.8,0.5,0.9,18.2,29.1 c0-9.7,0-19.4,0-29.1c7,0,14.1,0,21.2,0c0,21.2,0,38.2,0,62.6c-11.1,0-22.6,0-33.6,0c-24-37.6-0.4-0.9-24.3-38.1 c-0.1,12.8,0.1,18.5,0,38.1C758.2,82.1,754.1,82.1,745.9,82"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#006940"
    },
    d: "M1012.7,82c0-16.2,0-31.9,0-48.1c-8.2-14-0.4-0.4-8.4-14.5c27.4,0,35.5,0,48.4,0c17.9,28.8,0.4,0.9,18.1,29.1 c0-9.7,0-19.4,0-29.1c7.1,0,14.2,0,21.2,0c0,21.2,0,38.2,0,62.6c-11.1,0-22.6,0-33.6,0c-23.9-37.6-0.4-0.9-24.3-38.1 c0,12.8,0.1,18.5,0,38.1C1024.9,82.1,1020.8,82.1,1012.7,82"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlandsbanken);
export default __webpack_public_path__ + "static/media/alandsbanken.d227080e857a012f11afe783cdd4bd88.svg";
export { ForwardRef as ReactComponent };